import { render, staticRenderFns } from "./ResetPass.vue?vue&type=template&id=47dffb7c&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ResetPass.vue"
export default component.exports